var SENTRY_RELEASE;SENTRY_RELEASE={name: "Primum", version: "0.0.22"};